import { z } from 'zod';

/**
 * R-18 / RL-13 — the retailer's own Owner managing the account's logins. A person is added with a temporary
 * password the server generates; they must change it at first sign-in. The role is one of the retailer's
 * non-Owner roles; Owner is never assignable here.
 */
const name = z.string().trim().min(1, 'required').max(80);

export const zTeamMemberCreate = z.object({
  firstName: name,
  lastName: name,
  email: z.string().trim().toLowerCase().email().max(254),
  phone: z.string().trim().max(40).nullish(),
  roleId: z.string().uuid(),
}).strict();
export type TeamMemberCreate = z.infer<typeof zTeamMemberCreate>;

export const zTeamMemberUpdate = z.object({
  firstName: name,
  lastName: name,
  phone: z.string().trim().max(40).nullish(),
  roleId: z.string().uuid(),
}).strict();
export type TeamMemberUpdate = z.infer<typeof zTeamMemberUpdate>;
